import React, { FC } from 'react';
import Divider from '../../../ui/Divider/Divider';
import styles from './TrackingNumber.module.css';

interface TrackingNumberProps {
  featureName?: string;
  carrier: string;
  carrierLogoUrl: string;
}

const TrackingNumber: FC<TrackingNumberProps> = (props) => {
  const { carrier, carrierLogoUrl } = props;

  return (
    <div className={styles.container}>
      <Divider />
      <div className={styles.imgWrapper}>
        <img className={styles.carrierImg} src={carrierLogoUrl} alt={carrier} />
      </div>
    </div>
  );
};

export default TrackingNumber;
